/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 03/03/2022 19:56
 */

import { TreeNode } from '@infodata-group/inf-commons';
import { StandardMenuItem } from '../standard-menu-item';

export class GenericMenuItemNode extends TreeNode {
  public menuItem: StandardMenuItem;
  public override nodes: GenericMenuItemNode[];

  constructor(menuItem: StandardMenuItem) {
    super(menuItem.id, menuItem.label, menuItem.icon);
    this.menuItem = menuItem;
  }

  public addNode(menuItem: StandardMenuItem): void {
    this.menuItem.submenus.push(menuItem);
    this.nodes.push(menuItem.toNode());
  }

  public removeNode(item: GenericMenuItemNode): void {
    this.menuItem.submenus.splice(
      this.menuItem.submenus.findIndex((x) => x.id === item.id),
      1
    );
    this.nodes.splice(
      this.nodes.findIndex((x) => x.id === item.id),
      1
    );
  }
}
